/**
 * Enums and constants shared by backend and frontend. Everything here is a runtime
 * value the frontend bundles, so this file imports nothing. Sections are split out
 * into their own files once they grow.
 */

// -------- [ Example ] ------- //

/** Example status values demonstrating a shared enum. */
export enum ExampleStatus {
   ACTIVE = 'active',
   ARCHIVED = 'archived',
}

// -------- [ User and organization details ] ------- //

/** Maximum trimmed length of each user-details text field. Enforced by zod and the form rules, not the schema. */
export const USER_DETAILS_LIMITS = {
   title: 100,
   bio: 1000,
   phone: 32,
   location: 100,
   initials: 4,
} as const;

/** Maximum trimmed length of each organization-details text field. */
export const ORGANIZATION_DETAILS_LIMITS = {
   description: 2000,
   website: 2048,
   contactEmail: 254,
} as const;

// -------- [ User interface preferences ] ------- //

/** The user's theme choice; values map directly to the frontend theme names. */
export enum ThemePreference {
   SYSTEM = 'system',
   LIGHT = 'light',
   DARK = 'dark',
}

/**
 * The user's UI density choice. DEFAULT is the product's compact density;
 * COMFORTABLE is the roomier opt-out. COMPACT is a legacy stored value that
 * renders identically to DEFAULT; do not offer it in new UI.
 */
export enum DensityPreference {
   DEFAULT = 'default',
   COMFORTABLE = 'comfortable',
   COMPACT = 'compact',
}

/** A six-digit hex color with a leading '#'. */
export const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;

/** An absolute http or https URL. */
export const HTTP_URL_PATTERN = /^https?:\/\/[^\s/$.?#][^\s]*$/i;
